import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=35fdafca&"
import script from "./DocumentsTab.vue?vue&type=script&lang=js&"
export * from "./DocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fdafca')) {
      api.createRecord('35fdafca', component.options)
    } else {
      api.reload('35fdafca', component.options)
    }
    module.hot.accept("./DocumentsTab.vue?vue&type=template&id=35fdafca&", function () {
      api.rerender('35fdafca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/customization-tabs/DocumentsTab.vue"
export default component.exports